import Vue from "Vue";
import { Location } from "vue-router/types/router";

export class VueBase extends Vue {
	public isModified = false;

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public checkIsModified(location: Location): boolean {
    	return this.isModified;
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
	public closing(location: Location): void {

	}
}



// WEBPACK FOOTER //
// ./src/components/Controls/VueBase.ts